import styles from './Header.module.css';
import Svgs from 'assets/svgs';
import { useQuery } from 'hooks/useQuery';
import { LAST_NAV_TAB_KEY } from 'components/ds';

/** 클래스 이름을 해시된 이름으로 바꿉니다. 모르는 이름은 그대로 둡니다.
 *  이름을 바꾸지 않고 스코프만 씌우려고 둔 얇은 헬퍼입니다. */
const cls = (names?: string): string =>
    (names || '').split(' ').filter(Boolean)
        .map((n) => (styles as Record<string, string>)[n] || n).join(' ');

interface HeaderBtnProps {
    img?: string | null,
    text?: string,
    func?: () => void
}

interface HeaderProps {
    title: string,
    leftBtn?: HeaderBtnProps,
    rightBtn?: HeaderBtnProps,
    /** 서브페이지 여부 - true면 뒤로가기(좌측)와 닫기(우측) 버튼 모두 표시 */
    isSubPage?: boolean,
    /** X 닫기 버튼만 표시 (뒤로가기 없음) — 완료 화면용 */
    closeOnly?: boolean,
    onClose?: () => void,
    /** 뒤로가기 동작 override — bottom nav replace history 로 인해 navigate(-1) 가
     *  의도와 다르게 동작하는 화면에서 사용. 미지정 시 기본 history.back. */
    onBack?: () => void,
}

export const Header = ({ title, leftBtn, rightBtn, isSubPage, closeOnly, onClose, onBack }: HeaderProps) => {
    const { navigate } = useQuery();
    const isDarkMode = window.__DEVICE__?.isDarkMode;

    // 뒤로가기 (history back) — onBack 이 있으면 그걸 우선 호출
    const handleBack = () => {
        if (onBack) {
            onBack();
        } else {
            navigate(-1);
        }
    };

    // 닫기 (메인 탭으로 이동, 히스토리 초기화)
    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            // 마지막으로 방문한 Nav 탭으로 이동 (없으면 /home)
            // replace: true로 히스토리 초기화
            const lastNavTab = sessionStorage.getItem(LAST_NAV_TAB_KEY) || '/home';
            navigate(lastNavTab, { replace: true });
        }
    };

    const buttonRender = (btn: HeaderBtnProps) => {
        if (btn.text && btn.func) {
            return (
                <div className={cls("header_btn_wrapper")} onClick={btn.func}>
                    <span className={cls("header_btn_text")}>{btn.text}</span>
                </div>
            )
        }
        if(!!btn.img && btn.func) {
            return (
                <div className={cls("header_btn_wrapper")} onClick={btn.func}>
                    <img src={btn.img} style={isDarkMode ? {filter: 'invert(1)'} : {}} alt=""/>
                </div>
            )
        } else return <div className={cls("header_btn_wrapper")}></div>
    }

    return (
        <>
            <div className={cls("header_wrapper")}>
                <div className={cls("header_container")}>
                    {closeOnly
                        ? <div className={cls("header_btn_wrapper")}></div>
                        : isSubPage
                            ? buttonRender({img: Svgs.icBack24, func: handleBack})
                            : buttonRender(leftBtn || {})
                    }
                    <span className={cls("header_title")}>{title}</span>
                    {rightBtn?.func
                        ? buttonRender(rightBtn)
                        : (isSubPage || closeOnly)
                            ? buttonRender({img: Svgs.icClose24, func: handleClose})
                            : <div className={cls("header_btn_wrapper")}></div>
                    }
                </div>
            </div>
            <div className={cls("header_padding")} />
        </>
    )
}